import React, { Component } from 'react';
import { connect } from 'react-redux';
import Joyride from 'react-joyride';
import LeafletMapFullScreen from './components/maps/LeafletMapFullScreen';
import CategoryPane from './components/category/category';
import UserButton from './components/user/Button';

import ThingSpeakSource from './models/source/thingSpeak';

import './stylesheets/App.css';

class AppV2 extends Component {
  constructor() {
    super();
    this.state = {
      showModals: {
        aboutUs: false,
        faq: false,
        contribute: false,
        contactUs: false,
        login: false
      },
      activeKey: 'dashboard',
      joyride: {
        run: false,
        steps: [
          {
            target: '.neighbourhood-dashboard-settings-button',
            content: 'Here, you can choose different civic-environmental issues, and see data about them on your Neighbourhood Dashboard. Deselecting removes those data points from the map.',
            placement: 'bottom',
            disableBeacon: true,
            styles: {
              options: {
                zIndex: 50000
              }
            }
          },
          {
            target: '.collapse-databar',
            content: 'Use the collapse function to minimise the parameters menu, so you can see the full map.',
            placement: 'bottom',
            disableBeacon: true,
            styles: {
              options: {
                zIndex: 50000
              }
            }
          },
          {
            target: '.leaflet-map',
            content: 'Welcome to the Neighbourhood Dashboard! Your one stop to see what is happening in you neighbourhood. You will see Governance Data and Issues reported by Users as well as opportunities to solve like campaigns',
            placement: 'bottom',
            disableBeacon: true,
            styles: {
              options: {
                zIndex: 50000
              }
            }
          },
          {
            target: '.leaflet-inner-div-class',
            content: 'Drag the map and centre it to see the area around you. The crosshair here shows you where the maps centre currently is',
            placement: 'top',
            disableBeacon: true,
            styles: {
              options: {
                zIndex: 50000
              }
            }
          },
          {
            target: '.search-box-container-header',
            content: 'Type in your address/locality here to see all your Neighbourhood Info, just like any map',
            placement: 'bottom',
            disableBeacon: true,
            styles: {
              options: {
                zIndex: 50000
              }
            }
          },
          {
            target: '.category-container',
            content: 'Click on these icons to see the issues in the map above',
            placement: 'bottom',
            disableBeacon: true,
            styles: {
              options: {
                zIndex: 50000
              }
            }
          },

          {
            target: '.nav',
            content: 'Click on the Menu to see more options and to contact us',
            placement: 'bottom',
            disableBeacon: true,
            styles: {
              options: {
                zIndex: 50000
              }
            }
          },
          {
            target: '.close-right-dock',
            content: 'The right side panel shows governance data. This is a address book, so you know which official is accountable for different issues.',
            placement: 'left',
            disableBeacon: true,
            styles: {
              options: {
                zIndex: 50000
              }
            }
          },
        ],
      },
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.printAppState = this.printAppState.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(activeKey) {
    this.setState({ activeKey });
  }
  componentDidMount() {
    let source = new ThingSpeakSource({
      url: process.env["REACT_APP_THINGSPEAK_URL"]
    });

    ThingSpeakSource.register(source);
    source.fetchChannels();

    this.props.governanceData.initialize();

    this.props.openAQ.source.initialize();
    this.props.airQuality.initialize();

    this.props.gov.initialize();
    this.props.civic.initialize();
    this.props.jgrIcmyc.initialize();
    this.props.schoolData.initialize();

    let joyrideState = this.state.joyride;
    joyrideState.run = true;
    this.setState({ joyride: joyrideState });
  }
  showModal(event) {
    let showModals = this.state.showModals;
    if (event.target.id) {
      (Object.keys(showModals)).map((key) => {
        showModals[key] = false;
      });
      showModals[event.target.id] = true;
      this.setState({
        showModals: showModals
      });
    }
  }
  closeModal() {
    let showModals = this.state.showModals;
    (Object.keys(showModals)).map((key) => {
      showModals[key] = false;
    });
    this.setState({
      showModals: showModals
    });
  }
  printAppState() {
  }
  render() {
    const { steps, run } = this.state.joyride;
    return (<div>
      <Joyride
        floaterProps={{
          styles: {
            zIndex: 20000
          }
        }}
        steps={steps}
        run={run}
      />
      <LeafletMapFullScreen />
      <CategoryPane />
      <UserButton />
    </div>);
  }
}

function mapStateToProps(state, ownProps) {
  return ({
    thingSpeak: state.thingSpeak,
    governanceData: state.governanceData,
    civic: state.civic,
    openAQ: state.openAQ,
    airQuality: state.airQuality,
    gov: state.gov,
    jgrIcmyc: state.jgrIcmyc,
    schoolData: state.schoolData,
  });
}

export default connect(mapStateToProps)(AppV2);
// export default App;



// WEBPACK FOOTER //
// ./src/AppV2.js